import { render, staticRenderFns } from "./NavUserInfoCard.vue?vue&type=template&id=4f88949f"
import script from "./NavUserInfoCard.vue?vue&type=script&lang=js"
export * from "./NavUserInfoCard.vue?vue&type=script&lang=js"
import style0 from "./NavUserInfoCard.vue?vue&type=style&index=0&id=4f88949f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports